import { render, staticRenderFns } from "./CompetencyMatriz.vue?vue&type=template&id=30bd9d7e&scoped=true"
import script from "./CompetencyMatriz.vue?vue&type=script&lang=js"
export * from "./CompetencyMatriz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bd9d7e",
  null
  
)

export default component.exports